export const SOLUTIONS_EN = [
  {
    id: "coordinacion-segura",
    num: "01",
    title: "Secure coordination for sensitive teams and projects",
    reto:
      "Distributed teams handling sensitive information across scattered channels, with no identity governance, no device control and no revocation capability when the risk changes.",
    enfoque:
      "A private corporate channel with governed identity, controlled onboarding and offboarding, centralised validity and revocation, metadata minimisation and dedicated deployments where risk requires it.",
    capacidades: ["ONIX Messenger", "Device governance", "Dedicated deployments"],
    controles: "Validity, suspension and revocation of identities; onboarding audit; classification of conversations and files.",
    limites:
      "Encryption does not protect a compromised device or a capture made by a participant. Cryptographic properties must be verified per version.",
    tools: ["onix-messenger"],
  },
  {
    id: "operaciones-seguridad",
    num: "02",
    title: "Security operations, triage and response",
    reto:
      "A growing volume of unprioritised signals, uncoordinated response and no traceability of who decided what, when and with which information.",
    enfoque:
      "Centralised telemetry, signal correlation, risk prioritisation and coordination of an auditable response through cases, playbooks and executive reporting.",
    capacidades: ["ONIX AutoSOC / SIEM", "ONIX Sensorisation & cyber defence"],
    controles: "Documented triage, assisted automation under human supervision and a full audit of decisions.",
    limites:
      "Coverage, performance and retention depend on the scope, connected sources, applicable licences and acceptance tests.",
    tools: ["onix-autosoc-siem", "sensorizacion-ciberdefensa"],
  },
  {
    id: "investigacion-incidentes",
    num: "03",
    title: "Investigation of incidents, threats and relationships",
    reto:
      "Incidents and threats whose understanding requires connecting entities, indicators, locations and timelines scattered across multiple sources, while preserving the provenance of every data point.",
    enfoque:
      "Relational and geospatial correlation through graphs and operational maps, controlled static analysis of artefacts and the conversion of authorised corpora into actionable indicators.",
    capacidades: ["ONIX Tactical Graph", "ONIX Malware Static Analyzer", "DWI ONIX"],
    controles: "Confidence levels per data point, provenance and legitimate basis, human validation and controlled exports.",
    limites:
      "A graphical relationship does not prove causality or identity. Static analysis alone does not confirm runtime behaviour.",
    tools: ["onix-tactical-graph", "onix-malware-static-analyzer", "dwi-onix"],
  },
  {
    id: "analitica-video-evidencia",
    num: "04",
    title: "Video analytics and evidence management",
    reto:
      "Cameras and sessions that generate hours of unstructured material, with evidence that is hard to locate, preserve and present with integrity guarantees.",
    enfoque:
      "Turning cameras and authorised sessions into explainable events and traceable investigations, with integrity, defined retention and chain of custody over the evidence.",
    capacidades: ["ONIX Vision", "Evidence Vault", "Rules, zones and thresholds"],
    controles: "Evidence hashing and integrity, retention per scope, segregated access and controlled export.",
    limites:
      "Automated detection produces indicators and priorities, not legal conclusions. Accuracy and suitability must be validated in each scenario.",
    tools: ["onix-vision"],
  },
  {
    id: "monitorizacion-exposicion",
    num: "05",
    title: "Exposure monitoring and authorised sources",
    reto:
      "External attack surface, credentials, domains and mentions that evolve while the organisation lacks continuous visibility and prioritisation criteria.",
    enfoque:
      "External surface inventory, continuous telemetry and monitoring of authorised corpora with trackers, rules and human analytical validation before every alert.",
    capacidades: ["DWI ONIX", "ONIX Sensorisation & cyber defence", "Trackers and typosquatting"],
    controles: "Purpose and authorisation before every search, permitted sources and evidence with date, hash and confidence.",
    limites:
      "Searches are performed on the corpus that has been collected, imported or connected. There is no universal access to the entire dark web and no infallible attribution.",
    tools: ["dwi-onix", "sensorizacion-ciberdefensa"],
  },
  {
    id: "arquitecturas-dedicadas",
    num: "06",
    title: "Dedicated architectures and controlled integrations",
    reto:
      "Organisations that cannot operate on shared infrastructure or accept integrations that transfer data without classification, purpose or access control.",
    enfoque:
      "Design of dedicated deployments and governed interfaces between ONIX capabilities and customer systems: every flow serves a purpose, a classification and an access control.",
    capacidades: ["Dedicated deployments", "Governed interfaces", "Integration with cases and SIEM"],
    controles: "Environment segregation, least privilege, version control and traceability of every data flow.",
    limites:
      "Final properties depend on the scope, the deployed version, the integrations and the agreed acceptance tests.",
    tools: ["onix-messenger", "onix-autosoc-siem"],
  },
];
